export const UI_CHANGE_CURRENT_INVERTED_URL = 'ui/CHANGE_CURRENT_INVERTED_URL'
export const UI_CHANGE_LOADING = 'ui/CHANGE_LOADING'
export const UI_CHANGE_HOME_VISITED = 'ui/CHANGE_HOME_VISITED'
export const UI_CHANGE_INTRO = 'ui/CHANGE_INTRO'
